import * as PIXI from "pixi.js";
import ServiceLocator from "../ServiceLocator";

import { Signal } from "signals";
import { device_orientation_type } from "../service/DeviceOrientation";


export default abstract class Screen
{
    // #region Attributes //

    // protected:

    protected _root: PIXI.Container = null;

    // Signals.
    protected _onCompleted: Signal = null;

    // #endregion //


    public get onCompleted(): Signal { return this._onCompleted; }


    // #region Methods //

    // public:

    // virtual.
    public onEnter( params: any = null ): void
    {
        this._onCompleted = new Signal();

        this._root = new PIXI.Container();
        ServiceLocator.app.root.addChild( this._root );
    }

        // virtual.
        protected onPaused() {}

    // virtual.
    public onLeave(): void
    {        
        this._onCompleted.dispose();
        this._onCompleted = null;

        ServiceLocator.app.root.removeChild( this._root );
        this._root.destroy( { children: true } );
        this._root = null;
    }

    // virtual.
    public onUpdate( dt: number ): void {}

    // protected:

    protected createTitle( title: string ): PIXI.Text
    {
        let titleText: PIXI.Text = new PIXI.Text( title, { fontSize: 92, fill: "white", stroke: "black", strokeThickness: 10, fontStyle: "italic" } );
        titleText.anchor.set( 0.5, 0 );
        titleText.position.set( ServiceLocator.app.width * 0.5, 20 );

        return titleText;
    }

    // #endregion //
}